import React from "react";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import * as sidebarStyles from "./Sidebar.module.scss";

interface SidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}

const Sidebar = ({ isOpen, toggleSidebar }: SidebarProps) => (
  <div className={cx(sidebarStyles.sidebar, isOpen && sidebarStyles.open)}>
    <ul>
      <li>
        <Link
          className={sidebarStyles.about}
          onClick={toggleSidebar}
          activeClassName={sidebarStyles.active}
          to="/about/"
        >
          <FontAwesomeIcon icon="user" size="sm" />
          <span className={sidebarStyles.navLabel}>About</span>
        </Link>
      </li>
      <li>
        <Link
          className={sidebarStyles.projects}
          onClick={toggleSidebar}
          activeClassName={sidebarStyles.active}
          to="/projects/"
        >
          <FontAwesomeIcon icon={["fas", "folder-open"]} size="sm" />
          <span className={sidebarStyles.navLabel}>Projects</span>
        </Link>
      </li>
      <li>
        <Link
          className={sidebarStyles.skills}
          onClick={toggleSidebar}
          activeClassName={sidebarStyles.active}
          to="/skills/"
        >
          <FontAwesomeIcon icon="cog" size="sm" spin={true} />
          <span className={sidebarStyles.navLabel}>Skills</span>
        </Link>
      </li>
      <li>
        <Link
          className={sidebarStyles.contact}
          onClick={toggleSidebar}
          activeClassName={sidebarStyles.active}
          to="/contact/"
        >
          <FontAwesomeIcon icon={["fas", "envelope"]} size="sm" />
          <span className={sidebarStyles.navLabel}>Contact</span>
        </Link>
      </li>
    </ul>
  </div>
);

export default Sidebar;
